import { computed, reactive } from 'vue'

const config = reactive({})

const abConfig = computed(() => {
	return config
})

export default function useABConfig() {
	return {
		abConfig
	}
}